var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-5"},[_c('prismic-rich-text',{staticClass:"page-title d-flex w-100 mb-3",class:_vm.textClasses,style:({ color: _vm.color }),attrs:{"field":_vm.title}}),_vm._v(" "),_c('prismic-rich-text',{staticClass:"page-subtitle d-flex w-100",class:_vm.textClasses,style:({ color: _vm.color }),attrs:{"field":_vm.subtitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }